export const CashbookValidationScheema = (json, isEditMode) => {

    const MyPromise = new Promise((resolve, reject) => {
        var errorJson = {};
        if (json?.amount === undefined || json?.amount === '') {
            Object.assign(errorJson, { amount: "Amount cannot be empty *" });
        }
        if (json?.amount?.length > 0 || json?.amount) {
            const amount = parseFloat(json.amount);
            if (isNaN(amount) || amount <= 0) {
                Object.assign(errorJson, { amount: "Amount must be a valid positive number *" });
            }
        }
        if (json?.date === undefined || json?.date === '') {
            Object.assign(errorJson, { date: "Date cannot be empty *" });
        }
        if (json?.userId === undefined || json?.userId === '') {
            Object.assign(errorJson, { userId: "User selection is required *" });
        }
        if (json?.paymentMethod === undefined || json?.paymentMethod === '') {
            Object.assign(errorJson, { paymentMethod: "Payment method selection is required *" });
        }

        // Mandatory fields for cashOut
        if (json?.cashMethod === 'cashOut') {
            const proof = json?.proofUrl;
            const hasProof = Array.isArray(proof) ? proof.length > 0 : (proof !== undefined && proof !== '');
            if (!hasProof) {
                Object.assign(errorJson, { proofUrl: "Proof is mandatory for cash out *" });
            }
        }

        resolve(errorJson);
    })
    return MyPromise;
}
